import api from './config';

export function listFirmwares(params) {
  return api.get('/firmwares', { params });
}

export function getFirmware(id) {
  return api.get(`/firmwares/${id}`);
}

export function createFirmware(data) {
  return api.post('/firmwares', data);
}

export function updateFirmware(id, data) {
  return api.put(`/firmwares/${id}`, data);
}

export function deleteFirmware(id) {
  return api.delete(`/firmwares/${id}`);
}

// 上传固件文件到七牛云，返回 CDN 地址等信息
export function uploadFirmwareFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  // 不手动设置 Content-Type，让浏览器自动带 boundary
  return api.post('/firmwares/upload', formData);
}

// 获取当前放量比例下会收到该固件的设备列表（分页）
export function getRolloutDevices(firmwareId, params = {}) {
  return api.get(`/firmwares/${firmwareId}/rollout-devices`, { params });
}

